module.exports = __webpack_public_path__ + "img/html-evolution-8.7497c76a.jpg";